import { useEffect } from 'react'

import { sendSessionStartEvent } from '../helpers/sessionEvent'

/**
 * Catches a session that starts without a page load: the tab sat in the background long enough for
 * the session cookie to rotate, then came back. The load-time report is fired by the app-shell
 * container instead, because it has to wait for the first-session id to be written.
 */
export const useSessionStartTracking = () => {
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                sendSessionStartEvent()
            }
        }

        document.addEventListener('visibilitychange', handleVisibilityChange)

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange)
        }
    }, [])
}
